import { useEffect, useRef } from 'react';

// 렌더 시점엔 '직전 값'을 반환하고, 커밋 후 최신 값으로 갱신한다.
// 캐러셀에서 새로 mount 되는 카드가 '점프 전 위치'에서 슬라이드해 들어오게 할 때 사용.
export function usePrevious<T>(value: T): T {
  const ref = useRef(value);
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}
